import { maskPriceAmounts, roundConfig } from './round-config'
// A worker whose owner has switched prices off (0021) is sent none (functions/lib/prices.ts scrubs every answer). A
// copy of a day this phone saved BEFORE the switch still holds them (GPT-6.1's price check, 22 Oct 2026: a saved day
// showed "£30.00 to pay" and "£50.00 cash taken" after prices were hidden). So Today takes them out of any day it shows
// or saves while prices are hidden, the same boxes the server takes out. Kept in step with functions/lib/prices.ts.
const PRICE_KEYS = new Set([
  'breakdown_json', 'old_pence', 'new_pence', 'amount_pence', 'reg_price_pence', 'inside_price_pence', 'inside_pence', 'first_clean_price_pence', 'customer_price_pence',
  'gross_pence', 'worker_cut_pence', 'our_cut_pence', 'total_pence', 'price_pence', 'from_credit_pence', 'paid_in_pence',
  'to_pay_pence', 'cash_taken_pence', 'account_owed_pence', 'receipt_pence', 'kept_as_credit_pence', 'work_pence',
  'cash_expected_pence', 'part_of_pence', 'cash_collected_pence', 'tier_rate_pence', '_onward', 'each_pence',
])

// Prices written in notes are taken out too, the words kept ("£60 reg" reads "£… reg"), as the server does.
const NOTE_KEYS = new Set(['notice', 'reason', 'job_notes', 'parking_restrictions', 'preferred_times', 'call_notes', 'note', 'notes', 'blocked_note', 'last_time', 'said_note'])
export function withoutPrices<T>(value: T,currency:string=roundConfig().currency): T {
  if (Array.isArray(value)) return value.map(v=>withoutPrices(v,currency)) as unknown as T
  if (value && typeof value === 'object') {
    const out: Record<string, unknown> = {}
    for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
      // A list kept as text (a visit's extras_json, 0087) is taken apart inside too, as the server does (Astra's extras check 11).
      out[k] = PRICE_KEYS.has(k) ? null : NOTE_KEYS.has(k) && typeof v === 'string' ? maskPriceAmounts(v,currency)
        : k.endsWith('_json') && typeof v === 'string' ? jsonWithoutPrices(v,currency) : withoutPrices(v,currency)
    }
    return out as T
  }
  return value
}

function jsonWithoutPrices(text: string,currency:string): string | null {
  try { return JSON.stringify(withoutPrices(JSON.parse(text),currency)) } catch { return null }
}
